<template>
    <van-popup @click-overlay="closePopup" v-model:show="show" position="center" :style="{ height: '80%',zIndex:'10002' }"
        class="gamePopContainer">
        <van-row class="popHeader">
            <van-col span="20" offset="2" class="Poptitle">{{ $t('home.allGames') }}</van-col>
            <van-col span="2"><van-icon name="cross" size="16" @click="closePopup" /></van-col>
        </van-row>

        <div class="searchField">
            <van-field v-model="localValue" type="text" :placeholder="$t('home.searchGames')" class="custom-field">
                <template #left-icon>
                    <div class="left-section">
                        <img src="@/assets/themetwo/icon-search.png" alt="">
                    </div>
                </template>
            </van-field>
        </div>
        <div class="gameContainer">
            <GamePopup :data-set="gameSet" @load-more-game="clickShowMore" ref="gameListRef"  @go-to-play-game="GoToPlayGame"/>
            <div v-if="gamesLoading" class="loading"><van-loading type="spinner" size="60" /></div>
        </div>

    </van-popup>
</template>
<script lang="ts" setup>
import { ref, defineExpose, computed, watch, inject } from 'vue';
import GamePopup from '../../game/gamePopup.vue';
import { debounce, fetchGameList, goToPlayGame } from '@/view/home/supportScript';
import { useRouter } from 'vue-router';
const PAGE_SIZE = 20
const router = useRouter()
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const show = ref(false)
const localValue = ref('')
const openPopup = () => {
    show.value = true;
    getGameList()
}
const gameListRef = ref()
const gameList = ref<any>([])
const gameCount = ref(0)
const pageNum = ref(1)
const loading = ref(false)
const pageSize = ref(PAGE_SIZE)
const showLoadMore = ref(false)
const gamesLoading = ref(false)
const mainHeader = ref<{ url: string; display: boolean }>({ url: '', display: true })
const depositButon = ref({
    colorCode: '',
    display: false,
    redirectUrl: ''
})
const profileButtonData = ref({
    url: '',
    display: false,
    redirectUrl: ''
})
const gameSet = computed(() => ({
    gameCount: gameCount.value,
    gameList: gameList.value,
    showLoadMore: showLoadMore.value,
    loading: loading.value,
    //-------------------
    show: false,
    showPopover: false,
    groupList: [],
    activeItem: 0,
    balance: 0,
    mainHeader: mainHeader.value,
    depositButon: depositButon.value,
    profileButtonData: profileButtonData.value,
}))
const closePopup = () => {
    show.value = false;
}

const clickShowMore = () => {
    if (gameCount.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        getGameList()
    }
}

const getGameList = async () => {
    loading.value = true
    gamesLoading.value = true
    const { rows, total } = await fetchGameList(pageNum.value, pageSize.value, localValue.value)

    loading.value = false
    gamesLoading.value = false
    gameList.value = [...gameList.value, ...rows]
    gameCount.value = total
    showLoadMore.value = total > pageNum.value * pageSize.value
}
const GoToPlayGame = (data: any) => {
    goToPlayGame(router, openRegisterLoginPopup, data.id, data.makerId)
}
const resetList = () => {
    pageNum.value = 1;
    gameList.value = [];
};
const debouncedSearch = debounce(() => {
    resetList()
    getGameList()
}, 500)

watch(localValue, () => {
    debouncedSearch()
})
defineExpose({
    openPopup
})
</script>
<style scoped>
.gamePopContainer {
    width: 80%;
    border-radius: 15px;
    background-color: #312734;
}

.gamePopContainer::-webkit-scrollbar {
    display: none;
}

.van-overlay {
    backdrop-filter: blur(5px);
    z-index: 10001 !important;
}

.popHeader {
    background: linear-gradient(90deg, #c854ad 0, #432e4f);
    color: #fff;
    padding: 15px;
}

.Poptitle {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}

.searchField {
    padding: 15px;
}

.left-section {
    display: flex;
    align-items: center;
}

.left-section img {
    width: 25px;
    padding: 0 10px;
}

.searchField>>>.van-cell {
    padding: 5px;
    font-size: 14px;
    align-items: center;
    background: #2c1d31;
    border: 1px solid #65436f;
    border-radius: 30px;
}

.searchField>>>.van-field__control {
    font-size: 14px;
    font-weight: bold;
    color: #fff;
}

.searchField ::v-deep(.van-field__control::placeholder) {
    color: #ecd6ea53 !important;
    font-size: 14px !important;
    font-weight: 400;
    display: flex;
    align-items: center;
}

.gameContainer {
    padding: 0 5px;
    border-radius: 10px;
    height: 75%;
    overflow: hidden;
    overflow-y: auto;
    margin: 0 15px;
}

.gameContainer::-webkit-scrollbar {
    display: none;
}

.loading {
    padding: 30% 25px;
    display: flex;
    justify-content: center;
    text-align: center;
}
</style>